/* eslint-disable @typescript-eslint/no-unused-vars */
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { AuthenticateVehicleDto, ReauthenticateVehicleDto } from '../../app/features/vehicles/infrastructure/dto/mro-smartcar.dto';
import { MroSmartcarRepository } from '../../app/features/vehicles/infrastructure/mro-smartcar.repository';
import { checkCompatibilityResponseMock } from '../dataMocks/check-compatibility-response-mock';
import { getVehicleOdometerResponseMock } from '../dataMocks/get-vehicle-odometer-response-mock';
import { AuthenticateLocationResponse, CheckCompatibilityResponse, GetVehicleOdometerResponse } from '../../app/features/vehicles/domain/mro-smartcar.model';

export class MroSmartcarApiServiceMock implements MroSmartcarRepository {
    authenticateVehicle(authenticateVehicleDto: AuthenticateVehicleDto): Observable<AuthenticateLocationResponse> {
        return of();
    }
    compatibilityCheck(vin: string): Observable<CheckCompatibilityResponse> {
        return of(checkCompatibilityResponseMock);
    }

    getVehicleOdometer(rucVehicleId: string): Observable<GetVehicleOdometerResponse> {
        // const errorResponse = new HttpErrorResponse({
        //     error: { message: 'Conflict' },
        //     status: 409,
        //     statusText: 'Conflict',
        // });
        // return throwError(() => errorResponse);

        return of(getVehicleOdometerResponseMock);
    }

    deleteVehicleSmartcar(id: string, miles: number, odometerPhoto: File, feedback: string): Observable<void> {
        return of(void 0);
    }

    reauthenticateVehicle(reauthenticateVehicleDto: ReauthenticateVehicleDto): Observable<AuthenticateLocationResponse> {
        return of();
    }
}
